import clsx from 'clsx';

import {Calendar} from '@assets/icons';

const AppointmentIcon = ({isActiveTab, className, unansweredEvent, ...props}) => {
  return (
    <div className="relative">
      {unansweredEvent && unansweredEvent.length > 0
        ? (
          <div className={clsx(
            'absolute -right-2/5 -top-35% h-6 w-6 bg-primary rounded-full flex items-center justify-center border-1.5',
            isActiveTab ? 'border-pampas' : 'border-main',
          )}
          >
            <span className="text-white font-light-poppins font-black text-sm leading-5">
              {unansweredEvent.length}
            </span>
          </div>
        )
        : null}
      <Calendar className={className} {...props} />
    </div>
  );
};

export default AppointmentIcon;
